import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Modal, Tooltip, Typography, Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import Icon from '@mui/material/Icon'
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined'
import FlipCameraAndroidOutlinedIcon from '@mui/icons-material/FlipCameraAndroidOutlined'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import { useStyles } from '../../CaseDiagnosis/CaseDiagnosisStyles'
import PatientCaseHistory from './PatientCaseHistoryModal'
import TransferCaseModal from '../LabManager/TransferCaseModal'
import TransferCorrectCaseModal from '../LabManager/TransferCorrectCaseModal'
import AmendCaseModal from '../LabManager/AmendCaseModal'
import { RootState } from '../../../reducers'
import { CaseStatus } from '../../../utils/displayLabels'
import DeleteDialog from '../../HOC/DeleteDialog'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined'
import GroupRemoveOutlinedIcon from '@mui/icons-material/GroupRemoveOutlined'
import AssignCaseModal from '../LabManager/AssignCaseModal'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import LaunchPremeris from '../../CaseDiagnosis/LaunchPremeris'
import CircularProgress from '@mui/material/CircularProgress'
import {
  amend,
  unassignCase,
  refreshCaseData,
  setDraftEmpty,
  saveReportData,
  amendReportUpload,
  clearSessionToken,
  getSearchByTRFData,
} from '../../../actions'
import { DataGrid } from '@mui/x-data-grid'
import { clearPremerisApiCache, clearPremerisReportApiCache, setCaseData } from '../../../actions'
import { SearchColumns } from '../../HOC/table_def'

interface userObj {
  id?: number
  case_id?: number
  user_id?: string
  slide_status_id?: number
}

function SearchTableComponent({ trf_id }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [transferModalOpen, setTransferModalOpen] = useState(false)
  const [correctionTransferModalOpen, setCorrectionTransferModalOpen] = useState(false)
  const [amendModalOpen, setAmendModalOpen] = useState(false)
  const [resetAssignmentOpen, setResetAssignmentOpen] = useState(false)
  const dispatch = useDispatch()
  const { display_labels } = useSelector((state: RootState) => state.appConfig)
  const { role, user } = useSelector((state: RootState) => state.userLogin)
  const refreshData = useSelector((state: RootState) => state.refreshCase)
  const searchData = useSelector((state: RootState) => state.addSearchData)
  const caseData = useSelector((state: RootState) => state.getCaseData)
  const [userDetails, setUserDetails] = useState<userObj>({})
  const [isFirstPage, setFirstPage] = useState(false)
  const [assignModalOpen, setAssignModalOpen] = useState(false)
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [loading, setLoading] = useState(false)
  const [findUrl, setFindUrl] = useState('')
  const [premerisOpen, setPremerisOpen] = useState(false)
  const [isReadOnlyMode, setReadOnlyMode] = useState(false)
  const { re_unassignCase_success, re_unassignCase_error } = useSelector((state: RootState) => state.unassignResponse)
  const { re_amend_success, re_amend_error } = useSelector((state: RootState) => state.amendResponse)
  const [loadingStatus, setLoadingStatus] = useState(false)
  const [isInitiateAmendOpen, setInitiateAmendOpen] = useState(false)
  const [isAmendFlow, setAmendFlow] = useState(false)
  const { re_amendReport_success, re_amendReport_error } = useSelector((state: RootState) => state.saveAmendResponse)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)

  useEffect(() => {
    setFindUrl(window.location.pathname)
  }, [])

  const displayAssignedData = searchData.data
  const ActionsIconRender = {
    field: '',
    headerName: 'Actions',
    disableColumnMenu: true,
    width: 140,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    filterable: false,
    renderCell: (params) => {
      const disableTransferStages = [
        'PRIMARY_DIAGNOSIS_RESULTED_2HRWINDOW',
        'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED',
        'AMEND_RESULTED_RESULT_RELEASED',
        'CORRECT_RESULTED_2HRWINDOW',
        'CORRECT_RESULTED_RESULT_RELEASED',
      ]
      const unassignTransferStages = [
        'PRIMARY_DIAGNOSIS_ASSIGNED_INITIAL',
        'PRIMARY_DIAGNOSIS_ASSIGNED_READY',
        'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS',
      ]
      return (
        <div>
          <Tooltip title="Case History" placement="top-start">
            <Icon onClick={(event) => handleOpen(event, params.row)}>info_outlined</Icon>
          </Tooltip>
          {params.row.stage_id !== 'PRIMARY_DIAGNOSIS_NO_SLOTS_INITIAL' &&
            disableTransferStages.includes(params.row.stage_id) === false && (
              <>
                &nbsp;&nbsp;&nbsp;
                <Tooltip title="Transfer case" placement="top-start">
                  <PeopleAltOutlinedIcon onClick={(event) => handleTransferModalOpen(event, params.row)}>
                    Transfer
                  </PeopleAltOutlinedIcon>
                </Tooltip>
              </>
            )}
          {params.row.stage_id === 'PRIMARY_DIAGNOSIS_NO_SLOTS_INITIAL' && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Assign case" placement="top-start">
                <GroupAddOutlinedIcon onClick={(event) => handleAssignModalOpen(event, params.row)}>
                  Assign
                </GroupAddOutlinedIcon>
              </Tooltip>
            </>
          )}
          {unassignTransferStages.includes(params.row.stage_id) && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Unassign case" placement="top-start">
                <GroupRemoveOutlinedIcon onClick={(event) => handleResetAssignmentOpen(event, params.row)}>
                  Unassign case
                </GroupRemoveOutlinedIcon>
              </Tooltip>
            </>
          )}
          {(params.row.stage_id === 'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED' ||
            params.row.stage_id === 'AMEND_RESULTED_RESULT_RELEASED') && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Correction" placement="top-start">
                <BuildOutlinedIcon onClick={(event) => handleCorrectionTransferModalOpen(event, params.row)}>
                  Correction
                </BuildOutlinedIcon>
              </Tooltip>
            </>
          )}
          {(params.row.stage_id === 'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED' ||
            params.row.stage_id === 'CORRECT_RESULTED_RESULT_RELEASED' ||
            params.row.stage_id === 'AMEND_RESULTED_RESULT_RELEASED') && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Initiate Amendment" placement="top-start">
                <FlipCameraAndroidOutlinedIcon onClick={(event) => handleInitiateAmend(event, params.row)}>
                  Initiate Amendment
                </FlipCameraAndroidOutlinedIcon>
              </Tooltip>
            </>
          )}
        </div>
      )
    },
  }
  const CaseStatusRenderer = {
    field: 'workflow_stage_id',
    headerName: 'Case Status',
    width: 230,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    sortable: true,
    renderCell: (params) => {
      const caseStatus = CaseStatus(params.row.stage_id, role, display_labels)
      const statusArray = caseStatus.labelStr.split(', ')
      const style = { backgroundColor: caseStatus.labelColor }
      return (
        <>
          {statusArray.map((caseStatus, i) => (
            // eslint-disable-next-line react/jsx-key
            <React.Fragment key={i}>
              <Tooltip title={caseStatus} placement="top-start">
                <Stack direction="row" spacing={2}>
                  <Chip className={classes.chipSpacing} color="primary" style={style} label={caseStatus} />
                </Stack>
              </Tooltip>
            </React.Fragment>
          ))}
        </>
      )
    },
  }
  const PathologistActionsIconRender = {
    field: '',
    headerName: 'Actions',
    disableColumnMenu: true,
    width: 140,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    filterable: false,
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title="Case History" placement="top-start">
            <Icon onClick={(event) => handleOpen(event, params.row)}>info_outlined</Icon>
          </Tooltip>
          {(params.row.stage_id === 'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED' ||
            params.row.stage_id === 'CORRECT_RESULTED_RESULT_RELEASED' ||
            params.row.stage_id === 'AMEND_RESULTED_RESULT_RELEASED') && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Initiate Amendment" placement="top-start">
                <FlipCameraAndroidOutlinedIcon onClick={(event) => handleInitiateAmend(event, params.row)}>
                  Initiate Amendment
                </FlipCameraAndroidOutlinedIcon>
              </Tooltip>
            </>
          )}
        </div>
      )
    },
  }

  SearchColumns.push(CaseStatusRenderer)
  role !== 'NL_Pathologist' ? SearchColumns.push(ActionsIconRender) : SearchColumns.push(PathologistActionsIconRender)
  const handleOpen = (event, rowData: any) => {
    setUserDetails(rowData)
    setOpen(true)
  }

  const handleTransferModalOpen = (event, row: any) => {
    setUserDetails(row)
    setTransferModalOpen(true)
  }

  const handleCorrectionTransferModalOpen = (event, row: any) => {
    setUserDetails(row)
    setCorrectionTransferModalOpen(true)
  }

  const handleResetAssignmentOpen = (event, row: any) => {
    setUserDetails(row)
    setResetAssignmentOpen(true)
  }

  const handleResetAssignmentClose = () => {
    setResetAssignmentOpen(false)
  }

  const handleTransferModalClose = () => {
    setTransferModalOpen(false)
  }

  const handleCorrectionTransferModalClose = () => {
    setCorrectionTransferModalOpen(false)
  }

  const handleAmendModalClose = () => {
    setAmendModalOpen(false)
  }

  const handleAssignModalOpen = (event, row: any) => {
    setUserDetails(row)
    setAssignModalOpen(true)
  }

  const handleAssignModalClose = () => {
    setAssignModalOpen(false)
  }

  const handleClose = () => setOpen(false)

  const handleSubmit = async () => {
    await dispatch(
      unassignCase({
        caseid: userDetails.case_id,
        currentid: userDetails.user_id ? userDetails.user_id : user,
        userid: user,
      }),
    )
    setOpenSnackBar(true)
    await dispatch(
      getSearchByTRFData({
        user_id: user,
        trf_id: trf_id,
        user_role: role,
      }),
    )
    handleResetAssignmentClose()
  }

  const handleAmendCase = async (event, caseid: any, newUserId) => {
    setLoading(true)
    await dispatch(
      amend({
        userid: user,
        newid: newUserId,
        caseid: userDetails?.case_id,
      }),
    )
    await updateDataTable()
  }

  const updateDataTable = async () => {
    await dispatch(
      getSearchByTRFData({
        user_id: user,
        trf_id: trf_id,
        user_role: role,
      }),
    )
    handleAmendModalClose()
    setLoading(false)
    setInitiateAmendOpen(false)
    setOpenSnackBar(true)
  }

  const handlePremerisOpen = async (event, caseId: any, data) => {
    const filterAssignedResults = data.filter((value) => {
      return value.case_id == caseId
    })
    const patientName = `${filterAssignedResults[0].patient_last_name || ''}, ${
      filterAssignedResults[0].patient_first_name || ''
    }`
    setLoading(true)
    await handleRefreshCases(filterAssignedResults[0].case_number + '000')

    dispatch(
      setCaseData({
        pathologist: { first_name: filterAssignedResults[0].first_name, last_name: filterAssignedResults[0].last_name },
        pathologistId: filterAssignedResults[0].user_id,
        caseNumber: filterAssignedResults[0].case_number,
        procedureCodeId: filterAssignedResults[0].procedure_code,
        workflowId: filterAssignedResults[0].stage_id,
        patientName: patientName,
        caseId: caseId,
        nlOrderId: filterAssignedResults[0].nl_order_id,
        userCaseWorkflowId: filterAssignedResults[0].id,
        slideStatusId: filterAssignedResults[0].slide_status_id,
        mcFlag: filterAssignedResults[0].mc_flag,
        statFlag: filterAssignedResults[0].stat_flag,
      }),
    )
    setLoading(false)
    setPremerisOpen(true)
  }

  const handleInitiateAmend = (event, rowData: any) => {
    setInitiateAmendOpen(true)
    setAmendFlow(true)
    setLoadingStatus(true)
    ammendPremerisOpen(rowData)
  }

  const handleInitiateAmendClose = () => {
    setPremerisOpen(true)
  }

  const ammendPremerisOpen = async (rowData) => {
    /* Emptying the get draft report data when different case is selected, to prevent caching */
    dispatch(setDraftEmpty({ draft: {} }))

    const patientName = `${rowData.patient_last_name || ''}, ${rowData.patient_first_name || ''}`
    await handleRefreshCases(rowData.case_number + '000')
    dispatch(
      setCaseData({
        pathologist: { first_name: rowData.first_name, last_name: rowData.last_name },
        pathologistId: rowData.user_id,
        caseNumber: rowData.case_number,
        procedureCodeId: rowData.procedure_code,
        workflowId: 'AMEND_INITIATED',
        patientName: patientName,
        caseId: rowData.case_id,
        nlOrderId: rowData?.nl_order_id ? rowData?.nl_order_id : '',
        userCaseWorkflowId: rowData.id,
        slideStatusId: rowData.slide_status_id,
        mcFlag: rowData.mc_flag,
        statFlag: rowData.stat_flag,
      }),
    )
    setAmendFlow(true)
    setReadOnlyMode(true)
    setTimeout(() => {
      handleInitiateAmendClose()
    }, 3000)
  }

  const handleRefreshCases = async (trfBarcode) => {
    await dispatch(refreshCaseData({ trfBarcode: trfBarcode }))
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())
  }

  const handlePremerisClose = async () => {
    updateTrfStartDataTable()
    setInitiateAmendOpen(false)
    setAmendFlow(false)
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())
    setPremerisOpen(false)
  }

  const updateTrfStartDataTable = async () => {
    dispatch(
      getSearchByTRFData({
        user_id: user,
        trf_id: trf_id,
        user_role: role,
      }),
    )
  }

  const handleTRFComplete = () => {
    dispatch(
      saveReportData({
        trfBarcode: null,
        cptCodes: [],
        saveDraftJSON: {},
        reason: '',
        diagnosisLP: {},
        consultLP: [],
        calloutDecision: false,
        procedureCode: null,
      }),
    )
    dispatch(clearSessionToken())
    setTimeout(updateCaseStatus, 1500)
  }

  const updateCaseStatus = async () => {
    setOpenSuccessSnackBar(true)
    await dispatch(
      setCaseData({
        pathologist: caseData.pathologist,
        pathologistId: caseData.pathologistId,
        caseNumber: caseData.caseNumber,
        procedureCodeId: caseData.procedureCodeId,
        workflowId: 'AMEND_RESULTED_RESULT_RELEASED',
        patientName: caseData.patientName,
        caseId: caseData.caseId,
        nlOrderId: caseData.nlOrderId,
        userCaseWorkflowId: caseData.userCaseWorkflowId,
        slideStatusId: caseData.slideStatusId,
        mcFlag: caseData.mcFlag,
        statFlag: caseData.statFlag,
      }),
    )
    await dispatch(
      amendReportUpload({
        caseNumber: '',
        pathologistId: '',
        caseId: '',
        nlOrderId: '',
        userCaseWorkflowId: '',
        slideStatusId: '',
        mcFlag: '',
        statFlag: '',
        userId: '',
      }),
    )
    await dispatch(
      getSearchByTRFData({
        user_id: user,
        trf_id: trf_id,
        user_role: role,
      }),
    )
    setTimeout(() => setOpenSuccessSnackBar(false), 2000)
  }

  return (
    <>
      <div className={classes.container}>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box>
            <PatientCaseHistory userDetails={userDetails} handleClose={handleClose} />
          </Box>
        </Modal>
        <TransferCaseModal
          open={transferModalOpen}
          isSearch={true}
          trfId={trf_id}
          userId={user}
          onClose={handleTransferModalClose}
          userDetails={userDetails}
          setFirstPage={setFirstPage}
          filterName={null}
          filterValue={null}
          sortField={null}
          startDate={null}
          endDate={null}
        />
        <TransferCorrectCaseModal
          open={correctionTransferModalOpen}
          userId={user}
          isSearch={true}
          trfId={trf_id}
          onClose={handleCorrectionTransferModalClose}
          userDetails={userDetails}
          setFirstPage={setFirstPage}
          filterName={null}
          filterValue={null}
          sortField={null}
          startDate={null}
          endDate={null}
        />
        {openSnackBar && re_amend_success && (
          <SuccessSnackBar key={`${openSnackBar}`} message="Successfully moved the case for amend" />
        )}
        {openSnackBar && re_amend_error && (
          <ErrorSnackBar
            key={`error${openSnackBar}`}
            message="The selected case is already moved to either amend or correction"
          />
        )}
        <AmendCaseModal
          open={amendModalOpen}
          userId={user}
          loading={loading}
          onClose={handleAmendModalClose}
          userDetails={userDetails}
          handleAmendCase={handleAmendCase}
        />
        <AssignCaseModal
          open={assignModalOpen}
          userId={user}
          isSearch={true}
          trfId={trf_id}
          onClose={handleAssignModalClose}
          userDetails={userDetails}
          setFirstPage={setFirstPage}
          filterName={null}
          filterValue={null}
          sortField={null}
          startDate={null}
          endDate={null}
        />
        {openSnackBar && re_unassignCase_success && <SuccessSnackBar message="Successfully unassigned the case" />}
        {openSnackBar && re_unassignCase_error && <ErrorSnackBar message="Unable to unassign the case" />}
        {openSuccessSnackBar && re_amendReport_success && (
          <SuccessSnackBar message="Successfully updated case status" />
        )}
        {openSuccessSnackBar && re_amendReport_error && <ErrorSnackBar message="Failed to update case status" />}
        {resetAssignmentOpen && (
          <DeleteDialog
            header="Unassign"
            open={resetAssignmentOpen}
            onClose={handleResetAssignmentClose}
            handleSubmit={handleSubmit}
          />
        )}
        <Dialog
          open={refreshData && refreshData.fetchInProgress && isInitiateAmendOpen === false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.discardDialogHeight }}
        >
          <DialogTitle className={classes.dialogTitle}>Refreshing the case </DialogTitle>
          <DialogContent className={classes.discardDialogContent}>
            <DialogContentText id="alert-dialog-description">
              <div style={{ display: 'flex' }}>
                <div style={{ marginTop: '10px' }}>
                  <CircularProgress style={{ color: '#0A688D', marginRight: '10px', height: '20px', width: '20px' }} />
                </div>
                <div>Updating the case information from LabOS. This will take a few moments.</div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <Dialog
          open={isInitiateAmendOpen}
          onClose={handleInitiateAmendClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.discardDialogHeight }}
        >
          <DialogTitle className={classes.dialogTitle}>Initiating Amendment</DialogTitle>
          <DialogContent className={classes.discardDialogContent}>
            <DialogContentText id="alert-dialog-description">
              {loadingStatus && (
                <div style={{ display: 'flex' }}>
                  <div style={{ marginTop: '10px' }}>
                    <CircularProgress
                      style={{ color: '#0A688D', marginRight: '10px', height: '20px', width: '20px' }}
                    />
                  </div>
                  <div>Updating the case demographic information. This will take a few moments.</div>
                </div>
              )}
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <div className={classes.mt}>
          <Box
            sx={{
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#0d688d73',
                fontWeight: '600',
              },
              '& .MuiDataGrid-columnHeader--moving': {
                backgroundColor: 'transparent !important',
              },
              '& .MuiDataGrid-cell:hover': {
                cursor: 'pointer !important',
              },
              '& .MuiDataGrid-filterForm': { p: 2 },
            }}
          >
            <DataGrid
              getRowId={(row) => row.rowId}
              disableColumnSelector
              disableColumnFilter
              autoHeight
              pagination
              pageSize={10}
              rowsPerPageOptions={[10]}
              rows={displayAssignedData}
              columns={SearchColumns}
              loading={searchData?.fetchInProgress}
              onCellClick={(params, event) => {
                event.defaultMuiPrevented = true
                if (params.field === '') {
                  return
                } else {
                  setReadOnlyMode(true)
                  handlePremerisOpen(event, params.row.case_id, displayAssignedData)
                }
              }}
            />
          </Box>
        </div>
      </div>
      <Modal
        open={premerisOpen}
        onClose={handlePremerisClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <LaunchPremeris
          caseView={'search'}
          urlLink={findUrl}
          handlePremerisClose={handlePremerisClose}
          handleTRFComplete={handleTRFComplete}
          isReadOnlyMode={isReadOnlyMode}
          isAmendFlow={isAmendFlow}
        />
      </Modal>
    </>
  )
}

export default SearchTableComponent
